import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { TitleWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { CollectionTitleDSWidget } from './collection-title-ds-widget'
import { TitleWidgetLegacy } from './title-widget-legacy'

const TitleWidgetComponent = (props: PLTypedWidgetProps<TitleWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <CollectionTitleDSWidget {...props} />
  }
  return <TitleWidgetLegacy {...props} />
}

export const TitleWidget: PLTypedWidgetInterface<TitleWidgetData, WidgetType.TITLE> = {
  id: WidgetType.TITLE,
  errorBoundary: PLBaseErrorBoundary,
  render: TitleWidgetComponent,
}
